import { useMemo } from "react";
import { normalizeFooterData, normalizeMenuData } from "@wf/ui-kit"
import { DEFAULT_LANGUAGE } from "../../../constants";
import { localeToCode } from "../../../helpers";
import bdUatLayout from "../bdUatLayout.json";

type TLanguageItem = { name: string, displayName: string }

const useLayout = (lng: string, translate: (s: string) => string) => {
  const layoutLng = lng || DEFAULT_LANGUAGE;
  let layouts = bdUatLayout;


  return useMemo(() => {
    const languages: TLanguageItem[] = [];
    layouts.forEach(layout => {
      const { locale } = layout;
      const languageCode = localeToCode(locale.language_code);
      languages.push({ name: languageCode, displayName: languageCode });
    });

    const layout = layouts.find(l => localeToCode(l.locale.language_code) === layoutLng)!;

    const {
      attributes: { footer, menu, theme }
    } = layout;

    return {
      languages,
      layoutLng,
      theme: { colors: theme.colors },
      logos: theme?.logos,
      footerMenu: normalizeFooterData(footer, translate),
      menu: normalizeMenuData(menu),
    };
  }, [layouts, layoutLng, translate]);
};

export default useLayout;
